import axios from "axios";
import { authHeader } from "./authHeader";

const API_URL = process.env.REACT_APP_API_URL;


const getInspirationTemplates = (params) => {
    return axios.get(API_URL + '/api/inspiration/template', {
        params: params,
        headers: authHeader()
    });
};

const addInspirationTemplate = async (formData) => {
    const response = await axios.post(API_URL + "/api/inspiration/template", formData, {
        headers: authHeader()
    });
    return response;
};

const updateInspirationTemplate = async (id, formData) => {
    const response = await axios.put(API_URL + `/api/inspiration/template/${id}`, formData, {
        headers: authHeader()
    });
    return response;
};

const deleteInspirationTemplate = async (id) => {
    const response = await axios.delete(API_URL + `/api/inspiration/template/${id}`, {
        headers: authHeader()
    });
    return response;
};

const getInspirationTemplatesById = async (l_id) => {
    const response = await axios.get(API_URL + `/api/inspiration/template/${l_id}`, {
        headers: authHeader()
    });
    return response;
};

const INSPIRATIONTEMPLATEAPI = {
    getInspirationTemplates,
    addInspirationTemplate,
    updateInspirationTemplate,
    deleteInspirationTemplate,
    getInspirationTemplatesById
};

export default INSPIRATIONTEMPLATEAPI;

